var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path406, _path407;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHauptinsel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 454,
    height: 395,
    viewBox: "0 0 454 395",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M226.342 92.5391C103.038 92.5969 3.02295 152.356 3.02295 225.961C3.02295 299.601 85.1017 364.536 186.28 389.23C193.598 391.023 218.868 394.885 231.749 394.909C234.069 394.905 235.972 394.771 237.267 394.471C404.179 356.274 449.749 294.359 449.749 225.961C449.749 152.267 349.646 92.5969 226.342 92.5391Z",
    fill: "#3D3839"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M445.742 241.12C445.742 241.12 454.713 179.115 361.797 131.237C301.092 99.9568 222.531 91.5444 154.026 103.018C68.5073 119.857 5.77858 166.693 0.840043 222.625C0.266191 240.308 4.72177 255.61 7.20192 266.03C13.1785 282.178 22.9789 297.575 35.8244 311.834C61.8322 338.775 105.225 368.417 165.479 388.044C165.761 388.137 166.053 388.218 166.341 388.304C166.587 388.377 166.834 388.448 167.08 388.52C182.736 392.75 205.901 386.371 216.29 381.65C227.038 376.764 231.302 368.948 242.495 369.657C253.688 370.367 286.022 372.677 310.006 360.686C386.699 333.426 421.19 305.169 436.254 282.974C442.039 270.626 445.35 257.861 446.736 244.803C446.289 242.416 445.742 241.12 445.742 241.12Z",
    fill: "#64605F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M449.75 225.029C449.75 299.045 349.747 359.047 226.386 359.047C103.026 359.047 3.02295 299.045 3.02295 225.029C3.02295 151.012 103.026 91.0105 226.386 91.0105C349.747 91.0105 449.75 151.012 449.75 225.029Z",
    fill: "#65813F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M437.431 103.102C437.431 103.102 356.915 93.3267 307.034 24.604",
    stroke: "#3C3839",
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M257.468 125.592L279.437 138.276L301.406 125.592L279.437 112.908L257.468 125.592Z",
    fill: "#D1D2D6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M300.646 100.03L267.36 121.751L284.716 131.003L339.607 110.439C339.607 110.439 324.531 105.337 317.558 103.788C312.681 102.705 300.646 100.03 300.646 100.03Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M264.793 117.138L279.438 108.681L294.084 117.138L279.438 125.593L264.793 117.138Z",
    fill: "#D1D2D6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M264.793 117.139V125.594L279.438 134.051V125.594L264.793 117.139Z",
    fill: "#B3B2AA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 134.051L294.083 125.594V117.139L279.438 125.594V134.051Z",
    fill: "#747773"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 97.1575V95.2764L290.826 101.934V103.733L279.438 97.1575Z",
    fill: "#B3B2AA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 95.277L281.067 94.3364L290.826 100.233V101.935L279.438 95.277Z",
    fill: "#D1D2D6"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M277.808 109.62V63.1125L279.437 64.0531V110.56L277.808 109.62Z",
    fill: "#B3B2AA"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M281.067 109.62V63.1125L279.438 64.0531V110.56L281.067 109.62Z",
    fill: "#747773"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 82.6113V80.7302L290.826 87.3082V89.1854L279.438 82.6113Z",
    fill: "#B3B2AA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 80.7308L281.067 79.7903L290.826 85.687V87.3878L279.438 80.7308Z",
    fill: "#D1D2D6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 97.1575V95.2764L268.05 101.934V103.733L279.438 97.1575Z",
    fill: "#747773"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 95.277L277.809 94.3364L268.05 100.233V101.935L279.438 95.277Z",
    fill: "#D1D2D6"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 82.6113V80.7302L268.05 87.3872V89.1854L279.438 82.6113Z",
    fill: "#747773"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 80.7308L277.809 79.7903L268.05 85.687V87.3878L279.438 80.7308Z",
    fill: "#D1D2D6"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M264.793 117.136V70.6299L266.422 71.5704V118.076L264.793 117.136Z",
    fill: "#B3B2AA"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M268.052 117.138V70.6316L266.423 71.5721V118.078L268.052 117.138Z",
    fill: "#747773"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M277.808 124.652V78.1455L279.437 79.0861V125.592L277.808 124.652Z",
    fill: "#B3B2AA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M281.065 124.65L281.046 76.269L279.416 77.2096L279.436 125.591L281.065 124.65Z",
    fill: "#747773"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M290.826 117.138V70.6316L292.455 71.5721V118.078L290.826 117.138Z",
    fill: "#B3B2AA"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M294.083 117.137L294.061 68.7932L292.432 69.7338L292.455 118.078L294.083 117.137Z",
    fill: "#747773"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 49.0193V47.1382L290.826 53.7162V55.5934L279.438 49.0193Z",
    fill: "#B3B2AA"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 47.1366L281.067 46.196L290.826 52.0918V53.7935L279.438 47.1366Z",
    fill: "#D1D2D6"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 64.124V62.2429L290.826 68.8209V70.6991L279.438 64.124Z",
    fill: "#B3B2AA"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 62.2416L281.067 61.301L290.826 67.1977V68.8995L279.438 62.2416Z",
    fill: "#D1D2D6"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M266.423 104.678V102.797L277.811 109.455V111.253L266.423 104.678Z",
    fill: "#B3B2AA"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M266.423 102.796L268.052 101.855L277.811 107.752V109.454L266.423 102.796Z",
    fill: "#D1D2D6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M266.423 90.1323V88.2512L277.811 94.9091V96.7074L266.423 90.1323Z",
    fill: "#B3B2AA"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M266.423 88.2499L268.052 87.3093L277.811 93.206V94.9078L266.423 88.2499Z",
    fill: "#D1D2D6"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M292.455 104.755V102.875L281.067 109.531V111.33L292.455 104.755Z",
    fill: "#747773"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M292.455 102.875L290.827 101.935L281.067 107.83V109.532L292.455 102.875Z",
    fill: "#D1D2D6"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M292.455 90.21V88.3289L281.067 94.9868V96.785L292.455 90.21Z",
    fill: "#747773"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M292.455 88.3295L290.827 87.3889L281.067 93.2856V94.9874L292.455 88.3295Z",
    fill: "#D1D2D6"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M292.455 71.5971L292.431 69.7043L279.458 77.2102L279.457 79.0748L292.455 71.5971Z",
    fill: "#747773"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M294.084 68.7506L292.454 67.8101L277.83 76.2711L279.458 77.2117L294.084 68.7506Z",
    fill: "#D1D2D6"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M279.438 64.0857L279.4 62.187L266.422 69.6958L266.421 71.5711L279.438 64.0857Z",
    fill: "#747773"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M281.047 61.234L279.418 60.2944L264.793 68.7555L266.422 69.696L281.047 61.234Z",
    fill: "#D1D2D6"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M264.8 70.6986V53.7083L266.429 54.6488V71.6391L264.8 70.6986Z",
    fill: "#B3B2AA"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M268.058 68.7726V53.7083L266.43 54.6488V69.7132L268.058 68.7726Z",
    fill: "#747773"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M277.754 61.2577L277.758 46.1562L279.405 47.1085V62.2109L277.754 61.2577Z",
    fill: "#B3B2AA"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M281.033 61.2706V46.1672L279.404 47.1078V62.2102L281.033 61.2706Z",
    fill: "#747773"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M281.033 48.0279V46.1672L266.43 54.6488V56.486L281.033 48.0279Z",
    fill: "#747773"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M281.033 46.1673L279.379 45.2131L264.8 53.7083L266.429 54.6488L281.033 46.1673Z",
    fill: "#D1D2D6"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M277.828 76.3041V61.2397L279.457 62.1803V77.2447L277.828 76.3041Z",
    fill: "#B3B2AA"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M281.085 76.3041V61.2397L279.457 62.1803V77.2447L281.085 76.3041Z",
    fill: "#747773"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M290.779 68.7904L290.783 53.6899L292.43 54.6412V69.7446L290.779 68.7904Z",
    fill: "#B3B2AA"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 68.8041V53.7007L292.43 54.6412V69.7446L294.059 68.8041Z",
    fill: "#747773"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M294.084 55.592L294.06 53.6992L279.457 62.1807V64.018L294.084 55.592Z",
    fill: "#747773"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M294.061 53.6971L292.408 52.7429L277.828 61.2381L279.457 62.1786L294.061 53.6971Z",
    fill: "#D1D2D6"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M378.479 134.011C378.479 134.011 297.963 124.236 248.082 55.5137",
    stroke: "#3C3839",
    strokeMiterlimit: 10
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M266.423 71.6411V69.76L277.811 76.4179V78.2162L266.423 71.6411Z",
    fill: "#B3B2AA"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M266.423 69.7609L268.052 68.8203L277.811 74.717V76.4188L266.423 69.7609Z",
    fill: "#D1D2D6"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M266.423 56.5383V54.6572L277.811 61.3142V63.1124L266.423 56.5383Z",
    fill: "#B3B2AA"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M266.423 54.6578L268.052 53.7173L277.811 59.614V61.3148L266.423 54.6578Z",
    fill: "#D1D2D6"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M264.8 53.7001V38.6357L266.429 39.5763V54.6407L264.8 53.7001Z",
    fill: "#B3B2AA"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M268.058 53.7001V38.6357L266.43 39.5763V54.6407L268.058 53.7001Z",
    fill: "#747773"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M277.754 46.1871L277.758 31.0857L279.405 32.0379V47.1403L277.754 46.1871Z",
    fill: "#B3B2AA"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M281.033 46.1988V31.0964L279.404 32.037V47.1394L281.033 46.1988Z",
    fill: "#747773"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M311.059 15.4324V13.5728L234.99 57.7903V59.6275L311.059 15.4324Z",
    fill: "#747773"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M281.033 31.0946L279.379 30.1404L264.8 38.6355L266.429 39.5761L281.033 31.0946Z",
    fill: "#D1D2D6"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M311.065 13.555L309.411 12.5999L233.367 56.8349L234.995 57.7755L311.065 13.555Z",
    fill: "#D1D2D6"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M279.404 33.9197V32.0386L290.792 38.6166V40.4947L279.404 33.9197Z",
    fill: "#B3B2AA"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M279.404 32.037L281.033 31.0964L292.406 37.6725L290.792 38.6949L279.404 32.037Z",
    fill: "#D1D2D6"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M311.174 15.3405L311.151 13.4478L280.968 16.0637V17.901L311.174 15.3405Z",
    fill: "#747773"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M311.151 13.4471L309.288 12.6196L279.339 15.1265L280.969 16.066L311.151 13.4471Z",
    fill: "#D1D2D6"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M266.43 41.4582V39.5771L277.761 46.1376L276.272 47.0012L266.43 41.4582Z",
    fill: "#B3B2AA"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M266.43 39.5778L267.978 38.6646L279.379 45.265L277.871 46.2016L266.43 39.5778Z",
    fill: "#D1D2D6"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M264.736 38.7067V23.6423L266.365 24.5829V39.6473L264.736 38.7067Z",
    fill: "#B3B2AA"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M267.994 38.7067V23.6423L266.366 24.5829V39.6473L267.994 38.7067Z",
    fill: "#747773"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M277.688 31.1947L277.693 16.0942L279.339 17.0455V32.1489L277.688 31.1947Z",
    fill: "#B3B2AA"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M280.97 31.2071V16.1038L279.34 17.0443V32.1477L280.97 31.2071Z",
    fill: "#747773"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M280.97 17.9624V16.1018L266.366 24.5833V26.4206L280.97 17.9624Z",
    fill: "#747773"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M280.969 16.1017L279.315 15.1475L264.736 23.6426L266.365 24.5832L280.969 16.1017Z",
    fill: "#D1D2D6"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M289.303 28.2329V26.3518L300.746 32.9756L299.337 33.7144L289.303 28.2329Z",
    fill: "#B3B2AA"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M289.303 26.3527L290.853 25.4395L302.254 32.0399L300.746 32.9765L289.303 26.3527Z",
    fill: "#D1D2D6"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M299.893 21.865V19.9839L311.335 26.6077L310.253 27.6837L299.893 21.865Z",
    fill: "#B3B2AA"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M299.893 19.9843L301.442 19.071L312.843 25.6715L311.335 26.6081L299.893 19.9843Z",
    fill: "#D1D2D6"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M309.521 16.2061V14.325L320.963 20.9488L320.926 22.8425L309.521 16.2061Z",
    fill: "#B3B2AA"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M309.521 14.3251L311.07 13.4119L322.471 20.0123L320.963 20.9489L309.521 14.3251Z",
    fill: "#D1D2D6"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M277.828 61.2316V46.1672L279.457 47.1078V62.1722L277.828 61.2316Z",
    fill: "#B3B2AA"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M281.085 61.2316V46.1672L279.457 47.1078V62.1722L281.085 61.2316Z",
    fill: "#747773"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M290.779 53.7196L290.783 38.6191L292.43 39.5704V54.6738L290.779 53.7196Z",
    fill: "#B3B2AA"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M294.059 53.7315V38.6282L292.43 39.5687V54.6721L294.059 53.7315Z",
    fill: "#747773"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M324.109 22.9941L324.086 21.1023L248.017 65.3198V67.1571L324.109 22.9941Z",
    fill: "#747773"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M324.083 21.1026L322.22 20.2742L246.385 64.3825L248.013 65.3231L324.083 21.1026Z",
    fill: "#D1D2D6"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M324.109 22.9941L324.086 21.1023L293.903 23.7183V25.5555L324.109 22.9941Z",
    fill: "#747773"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M324.084 21.1019L322.469 20.0112L292.271 22.7802L293.9 23.7208L324.084 21.1019Z",
    fill: "#D1D2D6"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M279.404 19.0525V17.1714L290.792 23.7494V25.6266L279.404 19.0525Z",
    fill: "#B3B2AA"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M279.404 17.1742L281.033 16.2336L292.406 22.8097L290.792 23.8311L279.404 17.1742Z",
    fill: "#D1D2D6"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M277.763 46.2399V31.1755L279.391 32.1161V47.1805L277.763 46.2399Z",
    fill: "#B3B2AA"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M281.021 46.2399V31.1755L279.393 32.1161V47.1805L281.021 46.2399Z",
    fill: "#747773"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M290.717 38.7267L290.722 23.6262L292.368 24.5775V39.6809L290.717 38.7267Z",
    fill: "#B3B2AA"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M293.996 38.7386V23.6353L292.367 24.5758V39.6792L293.996 38.7386Z",
    fill: "#747773"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M294.02 25.5271L293.997 23.6353L279.393 32.1158V33.953L294.02 25.5271Z",
    fill: "#747773"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M293.996 23.6341L292.342 22.679L277.763 31.1741L279.391 32.1147L293.996 23.6341Z",
    fill: "#D1D2D6"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M266.366 26.4438V24.5627L277.762 31.1544V33.0706L266.366 26.4438Z",
    fill: "#B3B2AA"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M266.366 24.5629L267.914 23.6497L279.315 30.2501L277.807 31.1867L266.366 24.5629Z",
    fill: "#D1D2D6"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M264.736 23.6633V8.59888L266.365 9.53943V24.6038L264.736 23.6633Z",
    fill: "#B3B2AA"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M267.994 23.6633V8.59888L266.366 9.53943V24.6038L267.994 23.6633Z",
    fill: "#747773"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M277.69 16.1495L277.694 1.04907L279.342 2.00034V17.1037L277.69 16.1495Z",
    fill: "#B3B2AA"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M280.969 16.1615V1.05811L279.34 1.99866V17.102L280.969 16.1615Z",
    fill: "#747773"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M280.969 2.91776V1.05811L266.366 9.53865V11.3759L280.969 2.91776Z",
    fill: "#747773"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M280.969 1.05893L279.315 0.10376L264.736 8.59892L266.365 9.53947L280.969 1.05893Z",
    fill: "#D1D2D6"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M279.284 3.87573V1.99463L290.671 8.57263V10.4498L279.284 3.87573Z",
    fill: "#B3B2AA"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M279.284 1.99646L280.912 1.05591L292.285 7.63196L290.671 8.65341L279.284 1.99646Z",
    fill: "#D1D2D6"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M277.763 31.1948V16.1304L279.392 17.0709V32.1353L277.763 31.1948Z",
    fill: "#B3B2AA"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M281.023 31.1948V16.1304L279.394 17.0709V32.1353L281.023 31.1948Z",
    fill: "#747773"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M290.717 23.681L290.721 8.58057L292.368 9.53184V24.6352L290.717 23.681Z",
    fill: "#B3B2AA"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M293.995 23.6949V8.59155L292.367 9.5321V24.6355L293.995 23.6949Z",
    fill: "#747773"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M294.022 10.4834L293.997 8.59155L279.394 17.0721V18.9093L294.022 10.4834Z",
    fill: "#747773"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M293.996 8.59262L292.342 7.63745L277.763 16.1326L279.392 17.0732L293.996 8.59262Z",
    fill: "#D1D2D6"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M266.337 11.415V9.53491L277.734 16.1266V18.0427L266.337 11.415Z",
    fill: "#B3B2AA"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M266.337 9.53582L267.886 8.62256L279.287 15.222L277.78 16.1587L266.337 9.53582Z",
    fill: "#D1D2D6"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M233.363 58.6907L233.368 56.8379L234.997 57.7784L234.992 59.6313L233.363 58.6907Z",
    fill: "#B3B2AA"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M246.381 66.2371L246.386 64.3843L248.016 65.3248L248.01 67.1777L246.381 66.2371Z",
    fill: "#B3B2AA"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M266.39 24.6163L264.736 23.6621L233.367 56.8338L234.995 57.7743L266.39 24.6163Z",
    fill: "#D1D2D6"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M266.355 26.4891V24.6294L234.99 57.7894V59.6266L266.355 26.4891Z",
    fill: "#747773"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M255.734 47.6055V45.7253L267.177 52.3482L265.769 53.0879L255.734 47.6055Z",
    fill: "#B3B2AA"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M255.734 45.7243L257.284 44.811L268.685 51.4105L267.177 52.3471L255.734 45.7243Z",
    fill: "#D1D2D6"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M243.75 54.5408V52.6597L255.193 59.2835L254.111 60.3595L243.75 54.5408Z",
    fill: "#B3B2AA"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M243.75 52.6606L245.3 51.7473L256.701 58.3477L255.193 59.2844L243.75 52.6606Z",
    fill: "#D1D2D6"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M234.978 59.5996V57.7185L246.42 64.3423L246.383 66.2361L234.978 59.5996Z",
    fill: "#B3B2AA"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M234.978 57.7199L236.527 56.8076L247.927 63.4071L246.42 64.3437L234.978 57.7199Z",
    fill: "#D1D2D6"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M279.423 32.1751L277.769 31.2209L246.4 64.3926L248.029 65.3332L279.423 32.1751Z",
    fill: "#D1D2D6"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M279.388 34.0474V32.1877L248.023 65.3477V67.185L279.388 34.0474Z",
    fill: "#747773"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M386.478 202.454L408.445 215.138L430.414 202.454L408.445 189.77L386.478 202.454Z",
    fill: "#D1D2D6"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M435.561 176.713L392.53 203.186L409.886 212.437L446.574 199.857C446.574 199.857 444.047 192.387 441.878 187.838C439.729 183.328 435.561 176.713 435.561 176.713Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M393.801 193.998L408.447 185.542L423.093 193.998L408.447 202.453L393.801 193.998Z",
    fill: "#D1D2D6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M393.801 193.997V202.452L408.446 210.908V202.452L393.801 193.997Z",
    fill: "#B3B2AA"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 210.908L423.092 202.452V193.997L408.446 202.452V210.908Z",
    fill: "#747773"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 174.017V172.136L419.834 178.794V180.592L408.446 174.017Z",
    fill: "#B3B2AA"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 172.136L410.075 171.196L419.834 177.093V178.794L408.446 172.136Z",
    fill: "#D1D2D6"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M406.817 186.479V139.972L408.446 140.912V187.419L406.817 186.479Z",
    fill: "#B3B2AA"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M410.075 186.479V139.972L408.446 140.912V187.419L410.075 186.479Z",
    fill: "#747773"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 159.471V157.59L419.834 164.168V166.045L408.446 159.471Z",
    fill: "#B3B2AA"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 157.591L410.075 156.65L419.834 162.547V164.248L408.446 157.591Z",
    fill: "#D1D2D6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 174.017V172.136L397.059 178.794V180.592L408.446 174.017Z",
    fill: "#747773"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 172.136L406.817 171.196L397.059 177.093V178.794L408.446 172.136Z",
    fill: "#D1D2D6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 159.471V157.59L397.059 164.247V166.045L408.446 159.471Z",
    fill: "#747773"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 157.591L406.817 156.65L397.059 162.547V164.248L408.446 157.591Z",
    fill: "#D1D2D6"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M393.801 193.997V147.491L395.43 148.431V194.938L393.801 193.997Z",
    fill: "#B3B2AA"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M397.059 193.997V147.491L395.429 148.431V194.938L397.059 193.997Z",
    fill: "#747773"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M406.817 201.513V155.007L408.446 155.947V202.453L406.817 201.513Z",
    fill: "#B3B2AA"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M410.076 201.512L410.056 153.13L408.427 154.071L408.447 202.452L410.076 201.512Z",
    fill: "#747773"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M419.835 193.997V147.491L421.464 148.431V194.938L419.835 193.997Z",
    fill: "#B3B2AA"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M423.093 193.998L423.071 145.653L421.441 146.594L421.463 194.938L423.093 193.998Z",
    fill: "#747773"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 125.878V123.998L419.834 130.576V132.453L408.446 125.878Z",
    fill: "#B3B2AA"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 124L410.075 123.06L419.834 128.955V130.657L408.446 124Z",
    fill: "#D1D2D6"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 140.984V139.103L419.834 145.681V147.559L408.446 140.984Z",
    fill: "#B3B2AA"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M408.446 139.101L410.075 138.161L419.834 144.058V145.759L408.446 139.101Z",
    fill: "#D1D2D6"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M395.429 181.536V179.655L406.817 186.313V188.111L395.429 181.536Z",
    fill: "#B3B2AA"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M395.429 179.656L397.059 178.715L406.817 184.612V186.314L395.429 179.656Z",
    fill: "#D1D2D6"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M395.429 166.99V165.109L406.817 171.767V173.565L395.429 166.99Z",
    fill: "#B3B2AA"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M395.429 165.11L397.059 164.169L406.817 170.066V171.768L395.429 165.11Z",
    fill: "#D1D2D6"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M421.464 181.615V179.734L410.077 186.391V188.19L421.464 181.615Z",
    fill: "#747773"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M421.464 179.735L419.835 178.795L410.077 184.69V186.392L421.464 179.735Z",
    fill: "#D1D2D6"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M421.464 167.07V165.189L410.077 171.847V173.645L421.464 167.07Z",
    fill: "#747773"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M421.464 165.188L419.835 164.247L410.077 170.144V171.846L421.464 165.188Z",
    fill: "#D1D2D6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M421.463 148.458L421.44 146.566L408.466 154.072V155.936L421.463 148.458Z",
    fill: "#747773"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M423.09 145.61L421.462 144.67L406.836 153.131L408.465 154.072L423.09 145.61Z",
    fill: "#D1D2D6"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M408.447 140.945L408.409 139.047L395.43 146.555L395.429 148.431L408.447 140.945Z",
    fill: "#747773"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M410.055 138.093L408.427 137.152L393.801 145.614L395.429 146.555L410.055 138.093Z",
    fill: "#D1D2D6"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M393.809 147.556V130.566L395.438 131.507V148.497L393.809 147.556Z",
    fill: "#B3B2AA"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M397.067 145.631V130.566L395.438 131.507V146.571L397.067 145.631Z",
    fill: "#747773"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M406.762 138.119L406.767 123.018L408.414 123.97V139.073L406.762 138.119Z",
    fill: "#B3B2AA"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M410.042 138.131V123.029L408.414 123.97V139.072L410.042 138.131Z",
    fill: "#747773"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M410.042 124.888V123.027L395.438 131.509V133.346L410.042 124.888Z",
    fill: "#747773"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M410.042 123.027L408.388 122.073L393.809 130.568L395.438 131.508L410.042 123.027Z",
    fill: "#D1D2D6"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M406.836 153.164V138.1L408.465 139.04V154.105L406.836 153.164Z",
    fill: "#B3B2AA"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M410.093 153.164V138.1L408.464 139.04V154.105L410.093 153.164Z",
    fill: "#747773"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M419.789 145.65L419.793 130.55L421.441 131.501V146.604L419.789 145.65Z",
    fill: "#B3B2AA"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M423.07 145.664V130.561L421.441 131.501V146.605L423.07 145.664Z",
    fill: "#747773"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M423.092 132.45L423.068 130.557L408.464 139.039V140.876L423.092 132.45Z",
    fill: "#747773"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M423.069 130.559L421.415 129.604L406.836 138.1L408.465 139.04L423.069 130.559Z",
    fill: "#D1D2D6"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M395.429 148.501V146.62L406.817 153.278V155.076L395.429 148.501Z",
    fill: "#B3B2AA"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M395.429 146.62L397.059 145.68L406.817 151.577V153.278L395.429 146.62Z",
    fill: "#D1D2D6"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M395.429 133.398V131.517L406.817 138.174V139.972L395.429 133.398Z",
    fill: "#B3B2AA"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M395.429 131.517L397.059 130.577L406.817 136.474V138.174L395.429 131.517Z",
    fill: "#D1D2D6"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M393.809 130.56V115.496L395.438 116.436V131.501L393.809 130.56Z",
    fill: "#B3B2AA"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M397.067 130.562V115.497L395.438 116.438V131.502L397.067 130.562Z",
    fill: "#747773"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M406.762 123.047L406.767 107.946L408.414 108.898V124L406.762 123.047Z",
    fill: "#B3B2AA"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M410.042 123.06V107.958L408.414 108.899V124.001L410.042 123.06Z",
    fill: "#747773"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M440.068 92.2915V90.4319L364 134.649V136.487L440.068 92.2915Z",
    fill: "#747773"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M410.042 107.954L408.388 107L393.809 115.495L395.438 116.436L410.042 107.954Z",
    fill: "#D1D2D6"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M440.076 90.4142L438.422 89.46L362.378 133.695L364.008 134.636L440.076 90.4142Z",
    fill: "#D1D2D6"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M408.414 110.778V108.897L419.801 115.475V117.353L408.414 110.778Z",
    fill: "#B3B2AA"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M408.414 108.899L410.042 107.958L421.415 114.534L419.801 115.556L408.414 108.899Z",
    fill: "#D1D2D6"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M440.184 92.2024L440.159 90.3096L409.977 92.9256V94.7628L440.184 92.2024Z",
    fill: "#747773"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M440.158 90.3072L438.297 89.4797L408.347 91.9866L409.976 92.9261L440.158 90.3072Z",
    fill: "#D1D2D6"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M395.438 118.317V116.436L406.77 122.996L405.28 123.86L395.438 118.317Z",
    fill: "#B3B2AA"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M395.438 116.438L396.988 115.525L408.388 122.125L406.881 123.062L395.438 116.438Z",
    fill: "#D1D2D6"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M393.746 115.567V100.502L395.374 101.443V116.507L393.746 115.567Z",
    fill: "#B3B2AA"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M397.004 115.567V100.502L395.374 101.443V116.507L397.004 115.567Z",
    fill: "#747773"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M406.696 108.053L406.701 92.9529L408.348 93.9041V109.008L406.696 108.053Z",
    fill: "#B3B2AA"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M409.979 108.069V92.9653L408.35 93.9059V109.009L409.979 108.069Z",
    fill: "#747773"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M409.978 94.8223V92.9617L395.374 101.443V103.28L409.978 94.8223Z",
    fill: "#747773"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M409.979 92.9615L408.325 92.0073L393.746 100.502L395.374 101.443L409.979 92.9615Z",
    fill: "#D1D2D6"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M418.313 105.093V103.212L429.755 109.836L428.346 110.575L418.313 105.093Z",
    fill: "#B3B2AA"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M418.313 103.212L419.862 102.299L431.262 108.899L429.755 109.836L418.313 103.212Z",
    fill: "#D1D2D6"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M428.905 98.7246V96.8435L440.347 103.467L439.264 104.543L428.905 98.7246Z",
    fill: "#B3B2AA"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M428.905 96.8444L430.454 95.9312L441.855 102.532L440.347 103.468L428.905 96.8444Z",
    fill: "#D1D2D6"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M438.531 93.0654V91.1843L449.974 97.8072L449.936 99.7019L438.531 93.0654Z",
    fill: "#B3B2AA"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M438.53 91.183L440.079 90.2698L451.48 96.8702L449.972 97.8059L438.53 91.183Z",
    fill: "#D1D2D6"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M406.836 138.093V123.029L408.465 123.97V139.034L406.836 138.093Z",
    fill: "#B3B2AA"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M410.093 138.093V123.029L408.464 123.97V139.034L410.093 138.093Z",
    fill: "#747773"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M419.789 130.578L419.793 115.477L421.441 116.428V131.531L419.789 130.578Z",
    fill: "#B3B2AA"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M423.07 130.594V115.49L421.441 116.431V131.533L423.07 130.594Z",
    fill: "#747773"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M453.117 99.8559L453.093 97.9641L377.024 142.182V144.019L453.117 99.8559Z",
    fill: "#747773"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M453.093 97.9598L451.231 97.1323L375.395 141.241L377.023 142.181L453.093 97.9598Z",
    fill: "#D1D2D6"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M453.118 99.8559L453.094 97.9641L422.912 100.58V102.417L453.118 99.8559Z",
    fill: "#747773"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M453.092 97.962L451.479 96.8723L421.281 99.6413L422.91 100.582L453.092 97.962Z",
    fill: "#D1D2D6"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M408.414 95.9141V94.033L419.801 100.611V102.488L408.414 95.9141Z",
    fill: "#B3B2AA"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M408.414 94.0321L410.042 93.0916L421.415 99.6676L419.801 100.689L408.414 94.0321Z",
    fill: "#D1D2D6"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M406.77 123.099V108.034L408.399 108.975V124.039L406.77 123.099Z",
    fill: "#B3B2AA"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M410.03 123.099V108.034L408.4 108.975V124.039L410.03 123.099Z",
    fill: "#747773"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M419.726 115.585L419.73 100.484L421.378 101.436V116.539L419.726 115.585Z",
    fill: "#B3B2AA"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M423.004 115.6V100.497L421.375 101.437V116.541L423.004 115.6Z",
    fill: "#747773"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M423.028 102.385L423.005 100.493L408.4 108.974V110.811L423.028 102.385Z",
    fill: "#747773"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M423.003 100.494L421.349 99.5388L406.77 108.034L408.399 108.975L423.003 100.494Z",
    fill: "#D1D2D6"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M395.374 103.303V101.422L406.772 108.014V109.93L395.374 103.303Z",
    fill: "#B3B2AA"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M395.374 101.423L396.924 100.51L408.324 107.11L406.817 108.047L395.374 101.423Z",
    fill: "#D1D2D6"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M393.746 100.521V85.457L395.374 86.3976V101.462L393.746 100.521Z",
    fill: "#B3B2AA"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M397.003 100.521V85.457L395.374 86.3976V101.462L397.003 100.521Z",
    fill: "#747773"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M406.696 93.0096L406.701 77.9092L408.348 78.8604V93.9638L406.696 93.0096Z",
    fill: "#B3B2AA"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M409.979 93.0228V77.9194L408.35 78.86V93.9634L409.979 93.0228Z",
    fill: "#747773"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M409.978 79.7791V77.9194L395.374 86.4V88.2372L409.978 79.7791Z",
    fill: "#747773"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M409.979 77.9188L408.325 76.9636L393.746 85.4588L395.374 86.3993L409.979 77.9188Z",
    fill: "#D1D2D6"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M408.292 80.7368V78.8557L419.68 85.4337V87.3109L408.292 80.7368Z",
    fill: "#B3B2AA"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M408.292 78.8551L409.921 77.9146L421.293 84.4906L419.68 85.512L408.292 78.8551Z",
    fill: "#D1D2D6"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M406.772 108.056V92.9919L408.401 93.9325V108.997L406.772 108.056Z",
    fill: "#B3B2AA"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M410.031 108.056V92.9919L408.402 93.9325V108.997L410.031 108.056Z",
    fill: "#747773"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M419.726 100.541L419.73 85.4407L421.378 86.3919V101.495L419.726 100.541Z",
    fill: "#B3B2AA"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M423.006 100.556V85.4529L421.377 86.3934V101.497L423.006 100.556Z",
    fill: "#747773"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M423.03 87.3432L423.007 85.4514L408.402 93.932V95.7692L423.03 87.3432Z",
    fill: "#747773"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M423.005 85.4503L421.351 84.4951L406.772 92.9903L408.401 93.9308L423.005 85.4503Z",
    fill: "#D1D2D6"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M395.345 88.2751V86.395L406.743 92.9867V94.9029L395.345 88.2751Z",
    fill: "#B3B2AA"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M395.345 86.3937L396.895 85.4805L408.296 92.0799L406.788 93.0166L395.345 86.3937Z",
    fill: "#D1D2D6"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M362.373 135.551L362.379 133.698L364.008 134.639L364.003 136.491L362.373 135.551Z",
    fill: "#B3B2AA"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M375.39 143.097L375.395 141.244L377.023 142.185L377.018 144.038L375.39 143.097Z",
    fill: "#B3B2AA"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M395.402 101.476L393.748 100.522L362.378 133.694L364.008 134.634L395.402 101.476Z",
    fill: "#D1D2D6"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M395.364 103.351V101.491L364 134.651V136.488L395.364 103.351Z",
    fill: "#747773"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M384.742 124.464V122.583L396.183 129.206L394.775 129.946L384.742 124.464Z",
    fill: "#B3B2AA"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M384.742 122.585L386.29 121.672L397.691 128.272L396.183 129.208L384.742 122.585Z",
    fill: "#D1D2D6"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M372.76 131.401V129.52L384.202 136.144L383.119 137.22L372.76 131.401Z",
    fill: "#B3B2AA"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M372.76 129.52L374.308 128.607L385.71 135.207L384.202 136.144L372.76 129.52Z",
    fill: "#D1D2D6"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M363.986 136.459V134.578L375.429 141.202L375.392 143.095L363.986 136.459Z",
    fill: "#B3B2AA"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M363.986 134.579L365.536 133.665L376.937 140.266L375.429 141.202L363.986 134.579Z",
    fill: "#D1D2D6"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M408.434 109.037L406.78 108.083L375.409 141.255L377.039 142.195L408.434 109.037Z",
    fill: "#D1D2D6"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M408.396 110.908V109.048L377.032 142.209V144.046L408.396 110.908Z",
    fill: "#747773"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9396 193.293C107.163 196.686 107.163 202.284 98.9396 205.823C89.677 209.288 78.7185 209.288 69.4576 205.823C61.2362 202.431 61.2362 196.832 69.4576 193.293C78.7185 189.828 89.677 189.828 98.9396 193.293Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7436 199.309L79.3595 172.963C79.4646 174.038 78.9286 174.857 77.7509 175.597C75.5202 177 71.8225 177.194 69.4927 175.963C68.2821 175.324 67.6807 174.482 67.6929 173.599L67.69 173.599L65.0479 201.09C64.9095 202.64 65.8908 204.17 67.9764 205.272C71.782 207.283 77.8225 207.027 81.4662 204.736C83.9006 203.205 84.647 201.111 83.7436 199.309Z",
    fill: "#826955"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5095 123.093C75.7003 123.093 85.5834 133.285 85.5834 145.856C85.5834 158.428 75.7003 168.62 63.5095 168.62C51.3178 168.62 41.4355 158.428 41.4355 145.856C41.4355 133.285 51.3178 123.093 63.5095 123.093Z",
    fill: "#65A246"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M75.968 140.588C68.7025 144.57 56.9313 144.57 49.6658 140.588C46.3546 138.819 44.6073 136.43 44.2394 134.129C43.8708 137.05 45.619 139.968 49.6658 142.18C56.9313 146.161 68.7025 146.161 75.968 142.18C79.9238 139.968 81.7629 137.048 81.3951 134.129C81.0265 136.518 79.2807 138.815 75.968 140.588Z",
    fill: "#D9D9D0"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M77.9163 156.568C69.5745 161.047 56.0594 161.047 47.7176 156.568C43.9158 154.578 41.9096 151.89 41.4873 149.302C41.0641 152.587 43.0712 155.87 47.7176 158.359C56.0594 162.838 69.5745 162.838 77.9163 158.359C82.4582 155.87 84.5698 152.585 84.1475 149.302C83.7243 151.989 81.7199 154.573 77.9163 156.568Z",
    fill: "#D9D9D0"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8234 134.129C95.0143 134.129 104.897 144.321 104.897 156.893C104.897 169.464 95.0143 179.657 82.8234 179.657C70.6318 179.657 60.7495 169.464 60.7495 156.893C60.7495 144.321 70.6318 134.129 82.8234 134.129Z",
    fill: "#65A246"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M96.4598 151.622C88.9252 155.603 76.7181 155.603 69.1835 151.622C65.7497 149.853 63.9376 147.464 63.5561 145.163C63.1739 148.083 64.9868 151.002 69.1835 153.214C76.7181 157.195 88.9252 157.195 96.4598 153.214C100.562 151.002 102.469 148.082 102.088 145.163C101.706 147.551 99.8953 149.849 96.4598 151.622Z",
    fill: "#D9D9D0"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6136 167.608C90.2717 172.087 76.7567 172.087 68.4148 167.608C64.6131 165.618 62.6068 162.931 62.1845 160.342C61.7613 163.627 63.7684 166.911 68.4148 169.399C76.7567 173.878 90.2717 173.878 98.6136 169.399C103.156 166.911 105.267 163.626 104.845 160.342C104.422 163.029 102.417 165.614 98.6136 167.608Z",
    fill: "#D9D9D0"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5049 153.445C71.8861 153.445 78.6807 160.548 78.6807 169.31C78.6807 178.072 71.8861 185.176 63.5049 185.176C55.1232 185.176 48.3291 178.072 48.3291 169.31C48.3291 160.548 55.1232 153.445 63.5049 153.445Z",
    fill: "#65A246"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0717 166.566C66.959 169.552 58.6756 169.552 53.5628 166.566C51.2327 165.239 50.0031 163.448 49.7442 161.722C49.4849 163.912 50.715 166.101 53.5628 167.76C58.6756 170.746 66.959 170.746 72.0717 167.76C74.8555 166.101 76.1497 163.911 75.8908 161.722C75.6315 163.513 74.4029 165.236 72.0717 166.566Z",
    fill: "#D9D9D0"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M74.2211 177.604C68.3011 180.59 58.7098 180.59 52.7897 177.604C50.0917 176.277 48.6679 174.485 48.3682 172.76C48.0679 174.95 49.4923 177.139 52.7897 178.798C58.7098 181.784 68.3011 181.784 74.2211 178.798C77.4444 177.139 78.9429 174.949 78.6432 172.76C78.3429 174.551 76.9204 176.274 74.2211 177.604Z",
    fill: "#D9D9D0"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M244.342 136.846L87.7246 229.097L254.312 325.195L295.086 301.207L347.046 270.642L410.949 233.052L244.342 136.846Z",
    fill: "#5B703A"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M244.97 314.545L363.913 245.877V171.069L244.97 239.733V314.545Z",
    fill: "#787878"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M244.964 314.545L93.5596 227.122V152.318L244.964 239.734V314.545Z",
    fill: "#B5B3AB"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M363.908 171.068L212.485 83.6499L93.5596 152.316L244.963 239.732L363.908 171.068Z",
    fill: "#D2D3D8"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M252.452 258.354L257.944 255.169V242.35L252.452 245.537V258.354Z",
    fill: "#3C3839"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M263.478 251.979L268.974 248.783V235.976L263.478 239.169V251.979Z",
    fill: "#3C3839"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M274.511 245.586L280.007 242.412V229.59L274.511 232.776V245.586Z",
    fill: "#3C3839"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M285.543 239.203L291.05 236.031V223.233L285.543 226.386V239.203Z",
    fill: "#3C3839"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M296.569 232.825L302.07 229.636V216.814L296.569 220.001V232.825Z",
    fill: "#3C3839"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M307.607 226.434L313.127 223.247V210.446L307.607 213.622V226.434Z",
    fill: "#3C3839"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M318.648 220.067L324.148 216.863V204.06L318.648 207.24V220.067Z",
    fill: "#3C3839"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M329.674 213.682L335.174 210.482V197.677L329.674 200.847V213.682Z",
    fill: "#3C3839"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M340.724 207.289L346.22 204.105V191.284L340.724 194.471V207.289Z",
    fill: "#3C3839"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M351.733 200.913L357.229 197.713V184.91L351.733 188.085V200.913Z",
    fill: "#3C3839"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M252.452 278.182L257.944 275.001V262.205L252.452 265.38V278.182Z",
    fill: "#3C3839"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M263.478 271.807L268.974 268.621V255.811L263.478 258.987V271.807Z",
    fill: "#3C3839"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M274.511 265.428L280.007 262.235V249.425L274.511 252.612V265.428Z",
    fill: "#3C3839"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M285.543 259.044L291.05 255.858V243.048L285.543 246.237V259.044Z",
    fill: "#3C3839"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M296.569 252.658L302.07 249.477V236.66L296.569 239.852V252.658Z",
    fill: "#3C3839"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M307.607 246.282L313.127 243.096V230.276L307.607 233.451V246.282Z",
    fill: "#3C3839"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M285.543 279.426L291.05 276.239V263.429L285.543 266.619V279.426Z",
    fill: "#3C3839"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M296.569 273.04L302.07 269.859V257.042L296.569 260.233V273.04Z",
    fill: "#3C3839"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M307.607 266.666L313.127 263.48V250.659L307.607 253.835V266.666Z",
    fill: "#3C3839"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M318.648 239.891L324.148 236.702V223.906L318.648 227.082V239.891Z",
    fill: "#3C3839"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M318.648 259.387L324.148 256.198V243.402L318.648 246.578V259.387Z",
    fill: "#3C3839"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M329.674 233.516L335.174 230.311V217.52L329.674 220.684V233.516Z",
    fill: "#3C3839"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M340.724 227.121L346.22 223.934V211.119L340.724 214.308V227.121Z",
    fill: "#3C3839"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M351.733 220.747L357.229 217.541V204.742L351.733 207.931V220.747Z",
    fill: "#3C3839"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M252.452 298.033L257.944 294.849V282.022L252.452 285.215V298.033Z",
    fill: "#3C3839"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M263.478 291.642L268.974 288.456V275.661L263.478 278.836V291.642Z",
    fill: "#3C3839"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M274.511 285.275L280.007 282.077V269.273L274.511 272.447V285.275Z",
    fill: "#3C3839"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M329.674 253.349L335.174 250.158V237.353L329.674 240.543V253.349Z",
    fill: "#3C3839"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M340.724 246.956L346.22 243.773V230.97L340.724 234.134V246.956Z",
    fill: "#3C3839"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M351.733 240.584L357.229 237.387V224.586L351.733 227.767V240.584Z",
    fill: "#3C3839"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 259.808L232.014 256.622V242.353L237.5 245.539V259.808Z",
    fill: "#535453"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M226.466 253.416L220.981 250.224V235.978L226.466 239.17V253.416Z",
    fill: "#535453"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M215.452 247.038L209.955 243.852V229.591L215.452 232.778V247.038Z",
    fill: "#535453"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M204.422 240.656L198.911 237.469V223.234L204.422 226.388V240.656Z",
    fill: "#535453"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M193.364 234.273L187.87 231.072V216.817L193.364 220.003V234.273Z",
    fill: "#535453"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M182.349 227.888L176.837 224.706V210.449L182.349 213.625V227.888Z",
    fill: "#535453"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M171.314 221.508L165.803 218.322V204.061L171.314 207.242V221.508Z",
    fill: "#535453"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M160.267 215.115L154.772 211.928V197.678L160.267 200.849V215.115Z",
    fill: "#535453"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M149.245 208.726L143.746 205.551V191.285L149.245 194.472V208.726Z",
    fill: "#535453"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M138.203 202.356L132.715 199.159V184.913L138.203 188.088V202.356Z",
    fill: "#535453"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M127.182 195.951L121.673 192.765V178.523L127.182 181.71V195.951Z",
    fill: "#535453"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M116.152 189.596L110.641 186.398V172.143L116.152 175.312V189.596Z",
    fill: "#535453"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M105.105 183.197L99.6084 180.014V165.756L105.105 168.943V183.197Z",
    fill: "#535453"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 280.422L232.014 277.255V262.994L237.5 266.181V280.422Z",
    fill: "#535453"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M226.466 274.049L220.981 270.868V256.621L226.466 259.802V274.049Z",
    fill: "#535453"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M215.452 267.666L209.955 264.48V250.225L215.452 253.417V267.666Z",
    fill: "#535453"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M204.422 261.284L198.911 258.103V243.852L204.422 247.027V261.284Z",
    fill: "#535453"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M193.364 254.911L187.87 251.716V237.47L193.364 240.645V254.911Z",
    fill: "#535453"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M182.349 248.522L176.837 245.335V231.071L182.349 234.271V248.522Z",
    fill: "#535453"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M171.314 242.151L165.803 238.951V224.695L171.314 227.883V242.151Z",
    fill: "#535453"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M160.267 235.756L154.772 232.555V218.322L160.267 221.49V235.756Z",
    fill: "#535453"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M149.245 229.368L143.746 226.186V211.935L149.245 215.117V229.368Z",
    fill: "#535453"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M138.203 222.993L132.715 219.796V205.552L138.203 208.727V222.993Z",
    fill: "#535453"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M127.182 216.596L121.673 213.409V199.159L127.182 202.341V216.596Z",
    fill: "#535453"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M116.156 210.219L110.644 207.033V192.766L116.156 195.953V210.219Z",
    fill: "#535453"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M105.107 203.834L99.6104 200.653V186.402L105.107 189.583V203.834Z",
    fill: "#535453"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M237.5 301.065L232.014 297.901V283.641L237.5 286.821V301.065Z",
    fill: "#535453"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M226.466 294.689L220.981 291.502V277.26L226.466 280.423V294.689Z",
    fill: "#535453"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M215.452 288.306L209.955 285.133V270.867L215.452 274.043V288.306Z",
    fill: "#535453"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M204.422 281.928L198.911 278.747V264.481L204.422 267.668V281.928Z",
    fill: "#535453"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M193.364 275.546L187.87 272.343V258.093L193.364 261.286V275.546Z",
    fill: "#535453"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M182.349 269.164L176.837 265.982V251.71L182.349 254.898V269.164Z",
    fill: "#535453"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M171.314 262.79L165.803 259.59V245.336L171.314 248.524V262.79Z",
    fill: "#535453"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M160.267 256.398L154.772 253.206V238.95L160.267 242.126V256.398Z",
    fill: "#535453"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M149.245 250.004L143.746 246.817V232.563L149.245 235.749V250.004Z",
    fill: "#535453"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M138.203 243.628L132.715 240.433V226.187L138.203 229.368V243.628Z",
    fill: "#535453"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M127.182 237.24L121.673 234.047V219.795L127.182 222.993V237.24Z",
    fill: "#535453"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M116.156 230.861L110.644 227.675V213.408L116.156 216.595V230.861Z",
    fill: "#535453"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M105.107 224.469L99.6104 221.296V207.032L105.107 210.213V224.469Z",
    fill: "#535453"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M242.641 101.109L203.201 123.843H178.237L128.242 153.049L214.921 202.704L238.45 188.862L268.435 171.224L255.458 159.776L300.074 133.647L242.641 101.109Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M250.378 152.108L274.302 138.312V125.148L250.378 138.942V152.108Z",
    fill: "#787878"
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M250.376 152.109L204.421 125.579V112.423L250.376 138.944V152.109Z",
    fill: "#B5B3AB"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M274.301 125.148L228.321 98.624L204.421 112.422L250.377 138.943L274.301 125.148Z",
    fill: "#E3E4E7"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M209.593 198.167L250.778 174.41V151.733L209.593 175.502V198.167Z",
    fill: "#787878"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M209.593 198.17L130.458 152.486V129.818L209.593 175.503V198.17Z",
    fill: "#B5B3AB"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M250.778 151.733L171.632 106.05L130.458 129.818L209.593 175.5L250.778 151.733Z",
    fill: "#E3E4E7"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M141.462 126.423L169.802 110.059L164.618 107.064L136.267 123.424L141.462 126.423Z",
    fill: "#E8E8EB"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M141.461 132.695L136.267 129.702V123.423L141.461 126.423V132.695Z",
    fill: "#B5B3AB"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M141.463 132.696L169.803 116.343V110.059L141.463 126.423V132.696Z",
    fill: "#535453"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M149.414 131.016L177.751 114.652L172.57 111.655L144.216 128.005L149.414 131.016Z",
    fill: "#E8E8EB"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M149.415 137.288L144.217 134.286V128.005L149.415 131.016V137.288Z",
    fill: "#B5B3AB"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M149.409 137.289L177.746 120.928V114.652L149.409 131.017V137.289Z",
    fill: "#535453"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M157.353 135.601L185.706 119.238L180.509 116.243L152.172 132.602L157.353 135.601Z",
    fill: "#E8E8EB"
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M157.352 141.876L152.172 138.882V132.604L157.352 135.603V141.876Z",
    fill: "#B5B3AB"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M157.348 141.877L185.702 125.527V119.24L157.348 135.603V141.877Z",
    fill: "#535453"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M165.304 140.193L193.64 123.826L188.459 120.832L160.108 137.19L165.304 140.193Z",
    fill: "#E8E8EB"
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M165.303 146.463L160.108 143.47V137.191L165.303 140.193V146.463Z",
    fill: "#B5B3AB"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M165.298 146.464L193.635 130.106V123.827L165.298 140.194V146.464Z",
    fill: "#535453"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M173.233 144.787L201.586 128.415L196.387 125.418L168.05 141.788L173.233 144.787Z",
    fill: "#E8E8EB"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M173.231 151.058L168.05 148.059V141.786L173.231 144.786V151.058Z",
    fill: "#B5B3AB"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M173.24 151.061L201.593 134.704V128.418L173.24 144.79V151.061Z",
    fill: "#535453"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M181.191 149.368L209.531 133.004L204.344 130.009L175.994 146.368L181.191 149.368Z",
    fill: "#E8E8EB"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M181.192 155.64L175.994 152.646V146.368L181.192 149.368V155.64Z",
    fill: "#B5B3AB"
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M181.193 155.641L209.533 139.283V133.004L181.193 149.368V155.641Z",
    fill: "#535453"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M189.145 153.967L217.474 137.603L212.287 134.606L183.949 150.964L189.145 153.967Z",
    fill: "#E8E8EB"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M189.144 160.237L183.949 157.23V150.963L189.144 153.965V160.237Z",
    fill: "#B5B3AB"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M189.143 160.237L217.471 143.879V137.6L189.143 153.965V160.237Z",
    fill: "#535453"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M197.083 158.545L225.423 142.181L220.236 139.186L191.884 155.545L197.083 158.545Z",
    fill: "#E8E8EB"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M197.082 164.817L191.884 161.823V155.545L197.082 158.545V164.817Z",
    fill: "#B5B3AB"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M197.076 164.818L225.415 148.468V142.181L197.076 158.545V164.818Z",
    fill: "#535453"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M205.025 163.144L233.373 146.78L228.189 143.783L199.838 160.141L205.025 163.144Z",
    fill: "#E8E8EB"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M205.023 169.414L199.838 166.407V160.14L205.023 163.141V169.414Z",
    fill: "#B5B3AB"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M205.017 169.419L233.365 153.057V146.781L205.017 163.145V169.419Z",
    fill: "#535453"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M176.572 312.526C186.207 316.502 186.207 323.061 176.572 327.207C165.719 331.267 152.879 331.267 142.029 327.207C132.396 323.233 132.396 316.672 142.029 312.526C152.879 308.466 165.719 308.466 176.572 312.526Z",
    fill: "black",
    fillOpacity: 0.12
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M158.766 319.574L153.629 288.704C153.752 289.964 153.124 290.924 151.744 291.791C149.131 293.435 144.798 293.662 142.069 292.219C140.65 291.471 139.945 290.484 139.96 289.45L139.956 289.45L136.861 321.66C136.699 323.476 137.848 325.269 140.292 326.56C144.751 328.916 151.828 328.617 156.097 325.932C158.95 324.139 159.824 321.685 158.766 319.574Z",
    fill: "#826955"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M135.061 230.276C149.345 230.276 160.924 242.217 160.924 256.947C160.924 271.677 149.345 283.619 135.061 283.619C120.776 283.619 109.198 271.677 109.198 256.947C109.198 242.217 120.776 230.276 135.061 230.276Z",
    fill: "#65A246"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M149.658 250.777C141.145 255.442 127.353 255.442 118.84 250.777C114.961 248.704 112.914 245.906 112.483 243.209C112.051 246.631 114.099 250.051 118.84 252.642C127.353 257.307 141.145 257.307 149.658 252.642C154.293 250.051 156.447 246.63 156.017 243.209C155.585 246.008 153.539 248.7 149.658 250.777Z",
    fill: "#D9D9D0"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M151.94 269.503C142.166 274.751 126.331 274.751 116.557 269.503C112.102 267.171 109.752 264.022 109.257 260.989C108.761 264.839 111.113 268.685 116.557 271.601C126.331 276.849 142.166 276.849 151.94 271.601C157.261 268.685 159.735 264.837 159.24 260.989C158.745 264.138 156.396 267.166 151.94 269.503Z",
    fill: "#D9D9D0"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M157.685 243.209C171.969 243.209 183.549 255.151 183.549 269.881C183.549 284.611 171.969 296.552 157.685 296.552C143.401 296.552 131.822 284.611 131.822 269.881C131.822 255.151 143.401 243.209 157.685 243.209Z",
    fill: "#65A246"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M173.666 263.708C164.838 268.373 150.535 268.373 141.707 263.708C137.684 261.635 135.56 258.836 135.114 256.14C134.666 259.562 136.79 262.981 141.707 265.573C150.535 270.238 164.838 270.238 173.666 265.573C178.472 262.981 180.707 259.56 180.26 256.14C179.812 258.939 177.691 261.631 173.666 263.708Z",
    fill: "#D9D9D0"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M176.189 282.437C166.415 287.685 150.58 287.685 140.806 282.437C136.351 280.105 134.001 276.956 133.506 273.923C133.01 277.772 135.362 281.619 140.806 284.535C150.58 289.783 166.415 289.783 176.189 284.535C181.51 281.619 183.984 277.771 183.49 273.923C182.994 277.071 180.645 280.1 176.189 282.437Z",
    fill: "#D9D9D0"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M135.056 265.838C144.876 265.838 152.837 274.161 152.837 284.427C152.837 294.693 144.876 303.016 135.056 303.016C125.236 303.016 117.275 294.693 117.275 284.427C117.275 274.161 125.236 265.838 135.056 265.838Z",
    fill: "#65A246"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M145.092 281.214C139.101 284.712 129.396 284.712 123.405 281.214C120.675 279.659 119.234 277.56 118.931 275.538C118.627 278.104 120.069 280.669 123.405 282.613C129.396 286.111 139.101 286.111 145.092 282.613C148.353 280.669 149.87 278.103 149.566 275.538C149.262 277.637 147.823 279.656 145.092 281.214Z",
    fill: "#D9D9D0"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M147.612 294.144C140.676 297.643 129.438 297.643 122.502 294.144C119.341 292.59 117.672 290.491 117.321 288.469C116.969 291.035 118.638 293.599 122.502 295.543C129.438 299.042 140.676 299.042 147.612 295.543C151.389 293.599 153.145 291.034 152.793 288.469C152.441 290.568 150.775 292.586 147.612 294.144Z",
    fill: "#D9D9D0"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M390.616 266.453C383.333 270.541 383.333 277.286 390.616 281.55C398.82 285.725 408.526 285.725 416.728 281.55C424.01 277.463 424.01 270.717 416.728 266.453C408.526 262.277 398.82 262.277 390.616 266.453Z",
    fill: "#5B703A"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M396.599 233.859C383.06 233.859 372.085 245.311 372.085 259.438C372.085 273.565 383.06 285.017 396.599 285.017C410.139 285.017 421.113 273.565 421.113 259.438C421.113 245.311 410.139 233.859 396.599 233.859Z",
    fill: "#619640"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M379.011 270.27C389.964 275.775 402.878 275.775 413.829 270.27C418.809 267.427 421.109 263.698 421.109 259.967C421.495 265.171 418.686 270.09 414.006 272.4C403.055 277.906 390.142 277.906 379.19 272.4C375.139 270.11 372.43 266.014 371.907 261.388C372.828 265.262 375.435 268.521 379.011 270.27Z",
    fill: "#D9D9D0"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M381.505 254.461C390.999 259.258 402.208 259.258 411.702 254.461C414.883 252.971 417.184 250.078 417.92 246.645C418.455 250.019 416.321 253.561 411.702 256.237C402.208 261.034 390.999 261.034 381.505 256.237C376.888 253.571 374.934 250.019 375.288 246.645C375.975 250.102 378.291 253.013 381.505 254.461Z",
    fill: "#D9D9D0"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M370.1 286.149C364.776 289.137 364.776 294.067 370.1 297.184C376.096 300.236 383.19 300.236 389.185 297.184C394.507 294.197 394.507 289.266 389.185 286.149C383.19 283.097 376.096 283.097 370.1 286.149Z",
    fill: "#5B703A"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M373.332 261.119C363.436 261.119 355.414 269.49 355.414 279.817C355.414 290.143 363.436 298.514 373.332 298.514C383.23 298.514 391.251 290.143 391.251 279.817C391.251 269.49 383.23 261.119 373.332 261.119Z",
    fill: "#619640"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M360.481 287.729C368.486 291.752 377.925 291.752 385.929 287.729C389.57 285.651 391.251 282.925 391.251 280.198C391.533 284.002 389.48 287.597 386.059 289.285C378.055 293.31 368.617 293.31 360.612 289.285C357.651 287.611 355.67 284.618 355.288 281.236C355.961 284.068 357.867 286.45 360.481 287.729Z",
    fill: "#D9D9D0"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M362.307 276.17C369.246 279.676 377.439 279.676 384.379 276.17C386.704 275.081 388.386 272.967 388.924 270.457C389.314 272.924 387.754 275.513 384.379 277.469C377.439 280.975 369.246 280.975 362.307 277.469C358.932 275.52 357.504 272.924 357.763 270.457C358.265 272.984 359.958 275.112 362.307 276.17Z",
    fill: "#D9D9D0"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M318.4 174.6L309.968 179.744L261.071 209.134L262.404 209.936L327.877 179.744L318.4 174.6Z",
    fill: "#B8B9BE"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M260.702 189.884L262.086 190.627L262.086 210.315L260.807 209.583L260.702 189.884Z",
    fill: "#636363"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M263.469 189.884L262.086 190.627L262.086 210.315L263.365 209.583L263.469 189.884Z",
    fill: "#565656"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M274.953 181.671L276.336 182.413L276.336 202.102L275.057 201.37L274.953 181.671Z",
    fill: "#636363"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M277.722 181.671L276.339 182.413L276.339 202.102L277.618 201.37L277.722 181.671Z",
    fill: "#565656"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M289.808 173.11L291.191 173.852L291.191 193.541L289.912 192.809L289.808 173.11Z",
    fill: "#636363"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M292.577 173.11L291.194 173.852L291.194 193.541L292.473 192.809L292.577 173.11Z",
    fill: "#565656"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M302.446 165.766L303.829 166.508L303.83 186.197L302.55 185.465L302.446 165.766Z",
    fill: "#636363"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M305.216 165.766L303.833 166.637L303.833 186.197L305.112 185.465L305.216 165.766Z",
    fill: "#565656"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M252.736 155.561L307.61 123.761L310.559 125.454L255.685 157.254L252.736 155.561Z",
    fill: "#6D6C6C"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M255.658 157.238L310.585 125.439L310.585 175.933L255.658 207.733L255.658 157.238Z",
    fill: "#565656"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M256.676 158.039L309.138 127.599L309.138 174.743L256.677 205.183L256.676 158.039Z",
    fill: "#F9F9F9"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M252.745 155.551L255.673 157.232L255.673 207.712L252.849 206.04L252.745 155.551Z",
    fill: "#636363"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M256.661 205.18L309.137 174.744L309.972 175.181L256.661 206.294L256.661 205.18Z",
    fill: "#6D6C6C"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M309.134 174.739L309.134 127.589L309.881 127.132L309.967 175.185L309.134 174.739Z",
    fill: "#636363"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.153,
    cy: 177.6,
    rx: 7.9383,
    ry: 13.401,
    transform: "rotate(14.3879 278.153 177.6)",
    fill: "#59277F"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.075,
    cy: 152.054,
    rx: 6.07327,
    ry: 10.2525,
    transform: "rotate(14.3879 287.075 152.054)",
    fill: "#B4005F"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294.808,
    cy: 164.715,
    rx: 4.36562,
    ry: 7.36979,
    transform: "rotate(14.3879 294.808 164.715)",
    fill: "black"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 278.243,
    cy: 178.037,
    rx: 1.23207,
    ry: 2.05541,
    transform: "rotate(13.4279 278.243 178.037)",
    fill: "white"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 295.053,
    cy: 164.716,
    rx: 0.689475,
    ry: 1.00816,
    fill: "white"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 287.357,
    cy: 152.054,
    rx: 0.917023,
    ry: 1.34089,
    fill: "white"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M278.609 177.098L286.97 151.872L287.722 152.084L279.36 177.31L278.609 177.098Z",
    fill: "white"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M279.029 176.938L294.733 164.578L295.122 165.241L279.418 177.601L279.029 176.938Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHauptinsel);
export default __webpack_public_path__ + "static/media/Hauptinsel.129d06665412e78af3e3aaa8b9f201ba.svg";
export { ForwardRef as ReactComponent };